import { SsoConfigApi } from "../../api/ssoConfigApi";

export class OrganizationSsoRequest {
  enabled = false;
  data: SsoConfigApi;
}
